module.exports = __webpack_public_path__ + "img/no-results.24d79c7a.png";